import { clearLastProduct } from './clearLastProduct'

export function scrollLastProduct(ref: HTMLLIElement, catalogId: string) {
	/**
	 * Scroll to LI element
	 */
	ref?.scrollIntoView({ behavior: 'instant', block: 'center' })
	setTimeout(() => {
		/**
		 * Waiting for client product cards render
		 */
		ref?.scrollIntoView({ behavior: 'instant', block: 'center' })
		clearLastProduct(catalogId)
	})
}
